/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Shop_Guide_Video_Media_MissingInputs */

const vi_error_shop_guide_video_media_missing = /** @type {(inputs: Error_Shop_Guide_Video_Media_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`File đã chọn không còn trong Thư viện ảnh — hãy chọn lại.`)
};

/**

* @param {Error_Shop_Guide_Video_Media_MissingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_shop_guide_video_media_missing = /** @type {((inputs?: Error_Shop_Guide_Video_Media_MissingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Shop_Guide_Video_Media_MissingInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_shop_guide_video_media_missing(inputs)
});